import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';

import * as DataAccessProfessionsSelectors from './data-access-professions.selectors';

@Injectable()
export class DataAccessProfessionsFacade {
  professions$ = this.store.pipe(select(DataAccessProfessionsSelectors.getProfessions));

  getProfessionsById(professionIds: string[]) {
    return this.store.pipe(select(DataAccessProfessionsSelectors.getProfessionsById, { professionIds }));
  }

  constructor(private readonly store: Store) {}
}
